module.exports = __webpack_public_path__ + "img/carriers.56e12485.svg";